function helperCheckCopyKey (key) {
  return key !== '__proto__' && key !== 'constructor'
}

module.exports = helperCheckCopyKey



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/helperCheckCopyKey.js
// module id = 493
// module chunks = 75